import { render } from "./AboutS19.vue?vue&type=template&id=3c362a6d&scoped=true"
import script from "./AboutS19.vue?vue&type=script&lang=js"
export * from "./AboutS19.vue?vue&type=script&lang=js"

import "./AboutS19.vue?vue&type=style&index=0&id=3c362a6d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c362a6d"]])

export default __exports__